export default {
  buttons: {
    next: "التالي",
    prev: "السابق",
    skip: "تخطي",
    done: "إنهاء",
    gotIt: "فهمت",
  },
  messages: {
    dontShowAgainLabel: "لا تظهر مرة أخرى",
    stepNumbersOfLabel: "من",
  },
};
